import React, { useState } from "react";
import "./AccordianView.css";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import downArrowIcon from "../../assets/images/downArrowIcon.svg";
import PlannerAccordian from "./PlannerAccordian";
import { Info, ArrowDown } from 'lucide-react';
import { t } from "../../locales/translate";

const PlanAccordianView = ({ planDates, accordianDoctor }) => {
    const [showTooltip, setShowTooltip] = useState(null);

    const handleLeaveIconClick = (e, dateKey) => {
        e.preventDefault();
        e.stopPropagation();
        setShowTooltip(showTooltip === dateKey ? null : dateKey);
    };

    const handleLeaveIconMouseLeave = () => {
        setShowTooltip(null);
    };

    return (
        <div className="accordian-view-container">
            <div className="accordian-view-header">
                <div className="col-3 header-col">
                    <BodySmallMedium text={t("time")} color="#ffffff" />
                    <ArrowDown size={16} color="white"/>
                </div>
                <div className="col-3 header-col">
                    <BodySmallMedium text={accordianDoctor ? `${t("doctor")}` : `${t("city")}`} color="#ffffff" />
                    <ArrowDown size={16} color="white"/>
                </div>
                <div className="col-6 header-col">
                    <BodySmallMedium text={t("practiceLocation")} color="#ffffff" />
                    <ArrowDown size={16} color="white"/>
                </div>
            </div>
            {planDates && planDates?.length > 0 ? (
                planDates
                    .sort((a, b) => {
                        const dateA = new Date(a.planDate);
                        const dateB = new Date(b.planDate);
                        return dateA - dateB;
                    })
                    .map((plan, index) => {
                        const planDate = new Date(plan.planDate);
                        const formattedDate = planDate.toLocaleDateString('en-US', {
                            weekday: 'long',
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                        });
                        const dateKey = `${plan.planDate}-${index}`;

                        return (
                            <div key={index} className="plan-section">
                                <div className="plan-date-header">
                                    {plan.onLeave && (
                                        <div className="leave-info-container">
                                            <BodySmallMedium text='On Leave' color='#F23030'/>
                                            <Info 
                                                size={16} 
                                                className="leave-info-icon"
                                                onClick={(e) => handleLeaveIconClick(e, dateKey)}
                                                onMouseLeave={handleLeaveIconMouseLeave}
                                            />
                                            {showTooltip === dateKey && (
                                                <div className="leave-tooltip">
                                                    {plan.leaveMessage}
                                                </div>
                                            )}
                                        </div>
                                    )}
                            </div>
                                <PlannerAccordian plan={plan} />
                            </div>
                        );
                    })
            ) : (
                <div className="accordian-nodata">
                    <BodySmallMedium text={t("noDataFound")} color="#1E293B" />
                </div>
            )}
        </div>
    )
};

export default PlanAccordianView;